import React, { useState, useEffect } from "react";
import Header from "../components/header";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/footer";
import DentistTable from "../components/dentistTable";
import UploadDentistPopup from "../Popup/uploadDentistPopup";
import axiosInstance from "../services/axiosInstance";
import { PropagateLoader } from "react-spinners";

const DentistManagement = () => {
  const [searchItem, setSearchItem] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dentistList, setDentistList] = useState([]);

  const closePopup = () => {
    setOpenPopup(false);
    setTimeout(() => {
      getDentistList();
    }, 0);
  };

  const breadcrumbPaths = [
    { label: "Home", href: "/dashboard" },
    { label: "Dentist Management", href: "/dentist-management" },
  ];

  const getDentistList = async () => {
    if (isLoading) return;

    try {
      const response = await axiosInstance.get(
        "/api/Dentist/getAllActiveDentist"
      );
      if (response?.dentistList) {
        setDentistList(response.dentistList);
      }
    } catch (error) {
      console.error("Error fetching dentist list:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await getDentistList();
      } catch (error) {
        console.error("Error in fetchData:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <Header></Header>
      <div
        className="mx-auto container xl:w-full container p-6 py-16 pt-28 2xl:pt-36
      before:content-[''] before:bottom-0 before:right-0 before:w-[200px] before:h-[220px] before:bg-cover before:bg-right-bottom before:bg-no-repeat before:fixed before:bg-[url('./assets/images/schreiber-right.svg')] before:hidden lg:before:block before:-z-10
      after:content-[''] after:bottom-0 after:left-0 after:w-[200px] after:h-[220px] after:bg-cover after:bg-left-bottom after:bg-no-repeat after:fixed after:bg-[url('./assets/images/schreiber-left.svg')] after:hidden lg:after:block after:-z-10
      "
      >
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center mb-6">
          <Breadcrumb paths={breadcrumbPaths} />
          <input
            type="search"
            className="appearance-none border border-gray rounded-lg bg-white py-2 px-5 text-gray-600 placeholder:text-gray-400 hover:border-blue-600 focus:border-blue-600 focus:outline-none focus:shadow-outline"
            placeholder="Suche"
            onChange={(e) => {
              setSearchItem(e.target.value);
            }}
          />
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center min-h-60">
            <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
          </div>
        ) : (
          <>
            <DentistTable
              searchItem={searchItem}
              getDentistList={getDentistList}
              dentistList={dentistList}
              setDentistList={setDentistList}
            />
            <div className="text-end">
              <button
                className="z-auto mt-5 bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in"
                type="button"
                onClick={() => setOpenPopup(true)}
              >
                Add dentist
              </button>
            </div>
          </>
        )}

        <UploadDentistPopup openPopUp={openPopup} closePopUp={closePopup} />
      </div>
      <div className="xl:absolute bottom-0 w-full relative">
        {" "}
        <Footer />{" "}
      </div>
    </div>
  );
};

export default DentistManagement;
